import { combineReducers } from "redux";

import userSession from "./userSessionReducer";
import settings from "./settingsReducer";
import data from "./dataReducer";
import endUser from "./endUserReducer"
import stakeholder from "./stakeholderReducer"

export default combineReducers({
    userSession,
    settings,
    data,
    endUser,
    stakeholder
})